import { SSEService } from '@/shared/services/sse';

export const SSECoreReconfigureChannel = SSEService.createEventChannel('reconfigure');
export const SSECoreBarcodeScanChannel = SSEService.createEventChannel('core.barcode-scanned');
export const SSECoreLocationHoursChangedChannel = SSEService.createEventChannel('core.location-hours-changed');
